import { useState } from "react";
import { Database, Trash2 } from "lucide-react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";
import { useData } from "@/context/DataContext";

export const SampleDataButton = () => {
  const { leads, reps, load } = useData();
  const [busy, setBusy] = useState(false);
  const sampleLeads = leads.filter((l) => l.is_sample).length;
  const sampleReps = reps.filter((r) => r.is_sample).length;
  const hasSample = sampleLeads + sampleReps > 0;

  const run = async (method, msg) => {
    setBusy(true);
    try {
      await api[method]("/sample-data");
      await load();
      toast.success(msg);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  if (!hasSample) {
    return (
      <button type="button" data-testid="load-sample-data-btn" disabled={busy} onClick={() => run("post", "Sample data loaded")} className="btn-subtle text-xs">
        <Database className="h-3.5 w-3.5" /> Load sample data
      </button>
    );
  }
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button type="button" data-testid="delete-sample-data-btn" disabled={busy} className="btn-subtle text-xs">
          <Trash2 className="h-3.5 w-3.5" /> Delete sample data
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="max-w-[calc(100vw-2rem)] rounded-2xl border-slate-800 bg-slate-900 text-slate-100 sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete sample data?</AlertDialogTitle>
          <AlertDialogDescription data-testid="delete-sample-data-description">
            This removes {sampleLeads} sample leads and {sampleReps} sample reps. Leads and reps you created stay.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-sample-data-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="delete-sample-data-confirm-btn" onClick={() => run("delete", "Sample data deleted")}
            className="bg-indigo-600 text-white hover:bg-indigo-500">Delete sample data</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
